import { clearCookie, setCookie } from '@/common/utils';

export const GDPRCookieName = 'gdpr-consent';

export const GDPRConsentChangedEvent = 'gdpr-consent-changed';

export type GDPRCookieValueEnum = 'all' | 'essential' | undefined;

class ClientCookie {
  __name: string;
  constructor(name: string) {
    this.__name = name;
  }

  set(value: string) {
    setCookie(this.__name, value);
  }

  get() {
    return window.getCookieValue(this.__name);
  }

  clear() {
    clearCookie(this.__name);
  }
}

export const UserIdCookie = new ClientCookie('userId');
